import React from 'react'
import { lightTheme, darkTheme } from '../styles/theme';
import { ThemeProvider } from 'styled-components'

export default ({ children }) => {
  const theme = lightTheme
  // const [mounted, setMounted] = React.useState(false)
  console.log({...theme})
  // React.useEffect(() => {
  //   setMounted(true)
  // }, [])
    
  const body = 
    <ThemeProvider theme={{theme : theme}}>
      {children}
    </ThemeProvider>

  // prevents ssr flash for mismatched dark mode
  // if (!mounted) {
  //     return <div style={{ visibility: 'hidden' }}>{body}</div>
  // }

  return body
}